import { render, staticRenderFns } from "./VeJwQkJiankaoModal__Style#Drawer.vue?vue&type=template&id=06dd2bce&scoped=true"
import script from "./VeJwQkJiankaoModal__Style#Drawer.vue?vue&type=script&lang=js"
export * from "./VeJwQkJiankaoModal__Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./VeJwQkJiankaoModal__Style#Drawer.vue?vue&type=style&index=0&id=06dd2bce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dd2bce",
  null
  
)

export default component.exports